import { Grid, lighten, styled, Typography } from "@mui/material";
import { EXPENSE_REPORT_STATUS } from "../../../../../utils/constants/constants";

export const ExpenseReportWrapper = styled(Grid)({
  position: "relative",
  padding: "4px",

  "&:hover > .delete_button": {
    display: "block",
  },
});

export const ExpenseReportContainer = styled(Grid)(({ theme }) => ({
  boxShadow: theme.shadows[3],
  minWidth: "fit-content",
  width: "100%",
}));

export const DataContainer = styled(Grid)({
  width: "100%",
  height: "100%",
  minWidth: "600px",
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",

  "& > hr": {
    marginRight: "10px",
  },

  "& > div:last-child": {
    marginRight: "0px",
  },
  "& > .MuiGrid-root": {
    padding: "20px 10px",
  },
});

export const AdditionalText = styled("p")(({ theme }) => ({
  color: theme.palette.text.disabled,
  fontSize: theme.typography.body2.fontSize,
  margin: "0px",
}));

export const EmployeeDataContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "highlight",
})<{ highlight: boolean }>(
  ({ highlight, theme }) => ({
    ...(highlight && {
      backgroundColor: lighten(theme.palette.error.main, 0.9),
    }),
  }),
  {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    paddingLeft: "30px",
  }
);

export const ExpenseReportDetailsContainer = styled(Grid)({
  display: "flex",
});

export const MainInfoContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "highlight",
})<{ highlight: boolean }>(({ highlight, theme }) => ({
  ...(highlight && {
    backgroundColor: lighten(theme.palette.error.main, 0.9),
  }),
}));

export const DateAndCommentContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
});

export const CommentText = styled("p")({
  height: "100%",
  display: "flex",
  alignItems: "center",

  "& span": {
    display: "-webkit-box",
    WebkitLineClamp: "2",
    overflow: "hidden",
    WebkitBoxOrient: "vertical",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    lineHeight: "normal",
    fontSize: "20px",
  },
});

export const DateDescriptionBlock = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  flexWrap: "nowrap",
  gap: "5px",

  "& p": {
    margin: "0px",
  },
});

export const DescriptionCountriesContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  gap: "5px",
  flex: 1,
  alignItems: "center",
  justifyContent: "right",
});

export const AmountContainer = styled(Grid)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flex: 1.5,
});

export const AcceptedDifferenceamountContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignItems: "end",
});

export const Amount = styled("p")(({ theme }) => ({
  WebkitLineClamp: "2",
  overflow: "hidden",
  WebkitBoxOrient: "vertical",
  textOverflow: "ellipsis",
  whiteSpace: "normal",
  lineHeight: "normal",
  fontWeight: "bold",
  textAlign: "end",
  // marginRight: "30px",
  marginTop: "0px",
  fontSize: "30px",
  margin: 0,
  color: theme.palette.text.disabled,
}));

export const DifferenceAmount = styled(Grid)({
  display: "flex",
  alignItems: "center",
});

export const StatusesContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "status",
})<{ status: string }>(
  {
    display: "flex",
    flexDirection: "column",
    // justifyContent: "space-between",
    height: "auto",
    // display: "flex",
    flex: 1,
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  ({ status, theme }) => ({
    ...(status === EXPENSE_REPORT_STATUS.approved.id && {
      backgroundColor: lighten(theme.palette.success.main, 0.9),
    }),
    ...(status === EXPENSE_REPORT_STATUS.paid.id && {
      backgroundColor: lighten(theme.palette.success.main, 0.8),
    }),
    ...(status === EXPENSE_REPORT_STATUS.rejected.id && {
      backgroundColor: lighten(theme.palette.error.main, 0.9),
    }),
    ...(status === EXPENSE_REPORT_STATUS.submitted.id && {
      backgroundColor: lighten(theme.palette.primary.main, 0.9),
    }),
    ...(status === EXPENSE_REPORT_STATUS.returned_to_employee.id && {
      backgroundColor: lighten("#6F19DD", 0.9),
    }),
    ...(status === EXPENSE_REPORT_STATUS.draft.id && {
      backgroundColor: lighten(theme.palette.background.paper, 0.1),
    }),
  })
);

export const StatusContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  gap: "5px",
  alignContent: "flex-start",
  margin: 0,
  "& p": {
    margin: "0px",
    fontWeight: "bold",
  },
});

export const IconsContainer = styled(Grid)({
  width: "20px",
  display: "contents",
});

export const CountryIconsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  padding: "15px",
});

export const DateContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "3px",
  "& .MuiTypography-root": {
    lineHeight: 1.1,
  },
  color: theme.palette.secondary.light,
}));
export const NotesInfoContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "center",
  width: "100%",
});

export const IconTextContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  gap: "5px",
  alignItems: "center",
});
